<script>
import Modal from './Modal.svelte';
import { number } from '../libs/helpers';

export let sprint;
export let user;
export let totals;
export let autoOpened;
let modal;

$: start = sprint.start;
$: minutes = (sprint.end - start) / 1000 / 60;
$: duration = minutes < 60 ? `${minutes} Minutes` : `${minutes / 60} Hour`;
$: clock = `${minutes}:00`;
$: count = number(sprint.wordcount);
$: participants = totals.participants && number(totals.participants) || undefined;
$: total = totals.participants && number(totals.total) || undefined;
$: name = user && user.name;
$: uri = createLink({ start, duration, clock, count, participants, total, name });

function notAgain() {
  localStorage.dontShowResultsShare = true;
}

function createLink(data) {
  const params = new URLSearchParams();
  Object.keys(data).forEach(key => data[key] !== undefined && params.set(key, data[key]));
  return `https://wordsprints.org/results?d=${btoa(params.toString()).replace(/=+$/, '')}`;
}

function popup(event) {
  event.preventDefault();
  const anchor = event.target.closest('a');
  const url = anchor.href;
  const w = 626;
  const h = 436;
  let left = 0, top = 0;
  try {
    left = screen.availLeft + Math.round((screen.availWidth/2)-(w/2));
    top = screen.availTop + Math.round((screen.availHeight/2)-(h/2));
  } catch(err) {}
  const options = `toolbar=0,status=0,resizable=1,width=${w},height=${h},top=${top},left=${left}`;
  window.open(url, 'sharer', options);
  analytics.logEvent(`shared_link_${anchor.dataset.source}`);
}
</script>

<Modal title="Share your results" on:close bind:this={modal}>
  <section>
    {#if count}
    <p>You wrote {count} words in {duration}. Tell your friends!</p>
    {:else}
    <p>Your group wrote {totals.total} words in {duration}. Tell your friends!</p>
    {/if}
    <a href="http://twitter.com/intent/tweet?text={encodeURIComponent(`I wrote ${count} words in ${duration}! #amwriting\n\n${uri}`)}" target="_blank" on:click={popup}>
      <img src="/twitter.png" alt="Share on Twitter" width="64">
      <span class="label">Share it on Twitter</span>
    </a>
    <a href="https://www.facebook.com/sharer/sharer.php?display=popup&u={encodeURIComponent(uri)}" target="_blank" on:click={popup}>
      <img src="/facebook.png" alt="Share on Facebook" width="64">
      <span class="label">Share it on Facebook</span>
    </a>
  </section>
  <footer>
    {#if autoOpened}
    <button class="btn primary" on:click={notAgain}>Don’t Show Again</button>
    {/if}
    <button class="btn primary" on:click={() => modal.close()}>Close</button>
  </footer>
</Modal>

<style>
a {
  display: flex;
  padding: 8px 16px;
  align-items: center;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .2);
  transition: box-shadow .15s linear;
}
a:hover {
  position: relative;
  text-decoration: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .2), 0 3px 8px rgba(0, 0, 0, .2);
}
.label {
  margin-left: 16px;
  color: var(--warm-grey-600);
  font-size: var(--font-size-400);
}
</style>
